import React, { useEffect, useState } from "react";
import redirectURL from "../../redirectURL";
import moment from "moment";
const image = require("../../../assets/images/dashboard/notification.png")
// import io from 'socket.io-client';

// import { socketService } from "../optirun-admin/SocketService";

const formatTimeDifference = (createdDate) => {
    const currentDate = new Date();
    const timeDifferenceInMinutes = Math.floor((currentDate - createdDate) / 60000);

    if (timeDifferenceInMinutes < 60) {
        return `${timeDifferenceInMinutes} minute${timeDifferenceInMinutes !== 1 ? 's' : ''}`;
    } else if (timeDifferenceInMinutes < 1440) { // Less than 1 day (1440 minutes)
        const hours = Math.floor(timeDifferenceInMinutes / 60);
        const minutes = timeDifferenceInMinutes % 60;
        return `${hours} hour${hours !== 1 ? 's' : ''}` +
            (minutes > 0 ? ` ${minutes} minute${minutes !== 1 ? 's' : ''}` : '');
    } else {
        const days = Math.floor(timeDifferenceInMinutes / 1440);
        const remainingMinutes = timeDifferenceInMinutes % 1440;
        const hours = Math.floor(remainingMinutes / 60);
        const minutes = remainingMinutes % 60;

        return `${days} day${days !== 1 ? 's' : ''}` +
            (hours > 0 ? ` ${hours} hour${hours !== 1 ? 's' : ''}` : '') +
            (minutes > 0 ? ` ${minutes} minute${minutes !== 1 ? 's' : ''}` : '');
    }
};

const Notification = () => {
    const decipher = salt => {
        const textToChars = text => text.split('').map(c => c.charCodeAt(0));
        const applySaltToChar = code => textToChars(salt).reduce((a, b) => a ^ b, code);
        return encoded => encoded.match(/.{1,2}/g)
            .map(hex => parseInt(hex, 16))
            .map(applySaltToChar)
            .map(charCode => String.fromCharCode(charCode))
            .join('');
    }
    const decode = decipher("Z744cRBHYjQTsI6cOlNaUKbuEQF6MiEr");
    const localStorageRole = localStorage.getItem("role");
    const localStorageEmail = localStorage.getItem("email");

    const [notificationData, setNotificationData] = useState([]);
    const [notificationCount, setNotificationCount] = useState("");
    const [isHovered, setIsHovered] = useState(false);

    useEffect(() => {
        fetchNotifications();
    }, []);



    // useEffect(()=>{

    //     let socketCallback = (data) => {
    //         // console.log("test -- fetch notification");
    //         fetchNotifications()
    //     }
    //     socketService.on('fetchNotification', socketCallback);


    //     // Cleanup function to disconnect the socket when the component is unmounted
    //     return () => {
    //         socketService.off('fetchNotification', socketCallback);
    //     };
    // }, [])

    // useEffect(() => {

    //     //LOCAL
    //     const URL = "http://localhost:5033";

    //     // //DEV
    //     // const URL = "http://34.131.191.3:5033/";
    //     // //QA
    //     // const URL = "https://murugappaqa.enmovil.net";
    //     // // PROD
    //     // const URL = "https://murugappa.enmovil.net";

    //     var socket = io(URL, {
    //         transports: ['websocket'], // Ensure WebSocket transport is used
    //         reconnectionAttempts: 5,    // Retry connecting a few times
    //         reconnectionDelay: 1000,    // Optional: delay between retries
    //     });

    //     // Listen for connect event
    //     socket.on('connect', () => {
    //         console.log('test Connected to the server');
    //     });

    //     // Listen for connection errors
    //     socket.on('connect_error', (error) => {
    //         console.error('test Connection Error:', error);
    //     });

    //     // Listen for new bid updates
    //     socket.on('fetchNotification', (data) => {
    //         fetchNotifications()
    //     });

    //     // Cleanup function to disconnect the socket when the component is unmounted
    //     return () => {
    //         socket.disconnect();
    //         socket.off('fetchNotification');
    //     };
    // }, []);

   
    const fetchNotifications = () => {
        let params = {};
        
        let role = decode(localStorageRole).toLowerCase();
        if(role === "transporter" && localStorage.getItem("transporter")!=="All"){
            params["transporter_name"] = localStorage.getItem("transporter") || "";
            params["role"] = "transporter";
        }
        else if(role ===  "admin"){
            params["role"] = "admin";
        }
        

        redirectURL.post("/consignments/getNotifications", params).then((response) => {
                if(response.data.status === "success")
                setNotificationData(response.data.records || []);
                setNotificationCount(
                    response.data.records.filter(
                        (e) => !e?.seen_by?.includes(decode(localStorageEmail))
                    ).length
                );
            })
            .catch((error) => {
                console.error("Error fetching notifications:", error);
            });
    };

    const markNotificationsAsRead = () => {
        setNotificationCount("");

        let params = { user_email: decode(localStorageEmail) || "" };
        
        let role = decode(localStorageRole).toLowerCase() || "";

        if(role === "transporter" && localStorage.getItem("transporter")!=="All"){
            params["transporter_name"] = localStorage.getItem("transporter") || "";
            params["role"] = "transporter";
        }
        else if(role ===  "admin"){
            params["role"] = "admin";
        }

        redirectURL
            .post("/consignments/markNotificationsAsRead", params)
            .then(() => {
                // Update notifications to reflect the read state
                // fetchNotifications();
            })
            .catch((error) => {
                console.error("Error marking notifications as read:", error);
            });
    };

    const handleMouseEnter = () => {
        setIsHovered(true);
        // markNotificationsAsRead(); // Call API to mark notifications as read
    };

    const handleMouseLeave = () => {
        setIsHovered(false);
        fetchNotifications();
        markNotificationsAsRead(); // Call API to mark notifications as read
    };

    return (
        <li
    className="onhover-dropdown"
    onMouseEnter={handleMouseEnter}
    onMouseLeave={handleMouseLeave}
    style={{color: "#000"}}
>
<a className="txt-dark" style={{ position: "relative" }}>
    <img
        className="align-self-center pull-right mr-2"
        src={image}
        alt="header-notification"
        style={{ position: "relative", zIndex: 1 }}
    />
    {(decode(localStorageRole).toLowerCase() ==="transporter" &&
    notificationCount > 0) && (
        <span
            className="badge badge-pill badge-danger notification"
            style={{
                animation: "none",
                position: "absolute",
                top: "-5px", // Adjust to move the badge higher
                right: "-40px", // Adjust to move it horizontally
                zIndex: 2, // Ensure it appears above the icon
            }}
        >
            {notificationCount}
        </span>
    )}
</a>
    {(decode(localStorageRole).toLowerCase() === "transporter" && 
    <ul className="notification-dropdown onhover-show-div">
        {/* Header */}
        <li
            style={{
                fontWeight: "bold",
                padding: "10px",
                borderBottom: "1px solid #e9ecef",
                backgroundColor: "#f8f9fa",
            }}
        >
            Notifications
        </li>

        {/* Scrollable Content */}
        <div
            style={{
                maxHeight: "250px", // Adjust the height as needed
                overflowY: "auto",
            }}
        >
            {notificationData.length > 0 ? (
                notificationData.map((e, index) => {
                    const createdDate = moment.parseZone(new Date(e.created_date)).utcOffset("-05:30")._d;

                    // Check if the logged-in user's email is in the `seen_by` array
                    const isSeen = e?.seen_by?.includes(decode(localStorageEmail));

                    return (
                        <li
                            key={index}
                            style={{
                                backgroundColor: isSeen ? "#ffffff" : "#f8f9fa", // Light grey for seen, white for unseen
                                padding: "10px",
                                borderBottom: "1px solid #e9ecef",
                            }}
                        >
                            <div className="media">
                                <div className="media-body">
                                    <p
                                        style={{
                                            marginBottom: "0",
                                            fontWeight: isSeen ? "normal" : "bold", // Bold for unseen
                                            color: isSeen ? "#6c757d" : "#000000", // Grey for seen, black for unseen
                                        }}
                                    >
                                        {e.description}
                                    </p>
                                    <span
                                        style={{
                                            color: "#6c757d", // Muted grey for time text
                                            fontSize: "12px",
                                        }}
                                    >
                                        <i className="icofont icofont-clock-time p-r-5"></i>
                                        {formatTimeDifference(createdDate)} 
                                    </span>
                                </div>
                            </div>
                        </li>
                    );
                })
            ) : (
                <li style={{ padding: "10px", textAlign: "center" }}>
                    No new notifications
                </li>
            )}
        </div>
    </ul>)}
</li>

    );
};

export default Notification;
